export const PRIORITY_LEVELS = {
    IMMEDIATE: 'immediate',
    HIGH: 'high',
    NORMAL: 'normal',
    LOW: 'low'
};

export const PRIORITY_LABELS = {
    [PRIORITY_LEVELS.IMMEDIATE]: { label: 'Immediate', color: '#FF5630' },
    [PRIORITY_LEVELS.HIGH]: { label: 'High', color: '#FF8B00' },
    [PRIORITY_LEVELS.NORMAL]: { label: 'Normal', color: '#36B37E' },
    [PRIORITY_LEVELS.LOW]: { label: 'Low', color: '#6B778C' }
};